import HelpEmail from '../../../commons/help-email';
import withTracker from '../../../commons/with-tracker';

export default withTracker(HelpEmail);
